import marka from '@components/search/inputs/markaConstruction'
import model from '@components/search/inputs/modelNone'
import cena from '@components/search/inputs/cena'
import stan from '@components/search/inputs/stan'
import rata from '@components/search/inputs/rata'
import motogodziny from '@components/search/inputs/motogodziny'
import typ from '@components/search/inputs/typConstruction'
import rocznik from '@components/search/inputs/rocznik'
import lokalizacja from '@components/search/inputs/lokalizacjaZasieg'
import szukaj from '@components/search/inputs/szukaj'

import krajPochodzenia from '@components/search/inputsAdvanced/krajPochodzenia'
import stanPojazdu from '@components/search/inputsAdvanced/stanPojazdu'
import silnikNaped from '@components/search/inputsAdvanced/silnikNapedBudowlane'
import rodzajSprzedazy from '@components/search/inputsAdvanced/rodzajSprzedazy'
import nadwozie from '@components/search/inputsAdvanced/nadwozieBudowlany'
import dodatkoweWyposazenie from '@components/search/inputsAdvanced/dodatkoweWyposazenieBudowlane'

const constructionFormInputs = [
    marka,
    cena,
    stan,
    model,
    rata,
    motogodziny,
    typ,
    rocznik,
    lokalizacja,
]

const constructionAdvancedInputs = [
    krajPochodzenia,
    stanPojazdu,
    silnikNaped,
    rodzajSprzedazy,
    nadwozie,
    dodatkoweWyposazenie,
]

const constructionFormInputsMobile = [
    marka,
    model,
    cena,
    rocznik,
    typ,
    { type: 'blank' },
]

const constructionAdvancedInputsMobile = [
    lokalizacja,
    stan,
    szukaj,
    motogodziny,
    ...constructionAdvancedInputs,
]

export {
    constructionFormInputs,
    constructionAdvancedInputs,
    constructionFormInputsMobile,
    constructionAdvancedInputsMobile,
}